import {LiveDashboard} from "@common/ui-components/live/live-dashboard/live-dashboard";
import collection from "./container-collection.json";
import data from "./container-data.json";

export const ContainerThemeAuto = (props) => {
    return LiveDashboard({
        collection,
        defaultData: data,
        disabledTileActions: true,
        ...props,
    });
};
